import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

const useNavigateWithPersistedParams = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();

  // Only these query params will be kept when navigating
  const SEARCH_PARAMS_TO_KEEP = ['selectedTask'];

  const customNavigate = (path, options = {}, persistParams = true) => {
    const url = new URL(path, window.location.origin);

    if (persistParams) {
      searchParams.forEach((value, key) => {
        // Only add params that are in the whitelist
        if (SEARCH_PARAMS_TO_KEEP.includes(key)) {
          url.searchParams.set(key, value);
        }
      });
    }

    navigate(`${url.pathname}${url.search}`, options);
  };

  return customNavigate;
};

export default useNavigateWithPersistedParams;
